/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface OrganisationOtherNameDTO
 */
export interface OrganisationOtherNameDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrganisationOtherNameDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganisationOtherNameDTO
     */
    otherName?: string;
}

/**
 * Check if a given object implements the OrganisationOtherNameDTO interface.
 */
export function instanceOfOrganisationOtherNameDTO(value: object): value is OrganisationOtherNameDTO {
    return true;
}

export function OrganisationOtherNameDTOFromJSON(json: any): OrganisationOtherNameDTO {
    return OrganisationOtherNameDTOFromJSONTyped(json, false);
}

export function OrganisationOtherNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationOtherNameDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'otherName': json['otherName'] == null ? undefined : json['otherName'],
    };
}

export function OrganisationOtherNameDTOToJSON(json: any): OrganisationOtherNameDTO {
    return OrganisationOtherNameDTOToJSONTyped(json, false);
}

export function OrganisationOtherNameDTOToJSONTyped(value?: OrganisationOtherNameDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'otherName': value['otherName'],
    };
}


